/* ============================================================================
 * The Peanut Shell — Global Product Card V1 interactions
 * Loaded once globally with defer from layout/theme.liquid.
 * Uses event delegation so it works on:
 *   - Cards present on page load (homepage, collection)
 *   - Cards injected dynamically (YMAL via /recommendations, infinite scroll,
 *     Shopify Search & Discovery results).
 * ========================================================================== */

(function () {
  'use strict';

  var LOG_PREFIX = '[peanut-card]';
  var DEBUG = (typeof window !== 'undefined') && !!window.__PEANUT_CARD_DEBUG;
  function log() {
    if (!DEBUG) return;
    try { console.log.apply(console, [LOG_PREFIX].concat([].slice.call(arguments))); } catch (e) {}
  }

  // ── OPEN SHEET ──────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var atcBtn = e.target.closest && e.target.closest('.atc.select-size-state');
    if (!atcBtn) return;
    e.preventDefault();
    e.stopPropagation();
    var pid = atcBtn.getAttribute('data-product-id');
    if (!pid) return;
    openSheet(pid, atcBtn);
  });

  // ── BACKDROP CLICK (on the overlay shell, not the sheet itself) ─────────
  document.addEventListener('click', function (e) {
    var overlay = e.target;
    if (!overlay || !overlay.classList) return;
    if (overlay.classList.contains('sheet-overlay') &&
        overlay.classList.contains('active')) {
      closeSheet(overlay.getAttribute('data-product-id'), false);
    }
  });

  // ── ESCAPE KEY ──────────────────────────────────────────────────────────
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var active = document.querySelector('.sheet-overlay.active');
    if (active) closeSheet(active.getAttribute('data-product-id'), false);
  });

  // ── SIZE PILL SELECTION ─────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.size-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var pid = btn.getAttribute('data-product-id');
    var row = document.getElementById('sheet-sizes-' + pid);
    if (!row) return;
    row.querySelectorAll('.size-btn').forEach(function (b) {
      b.classList.remove('size-selected');
    });
    btn.classList.add('size-selected');

    var sheetAtc = document.querySelector('[data-sheet-atc][data-product-id="' + pid + '"]');
    if (sheetAtc) sheetAtc.removeAttribute('disabled');
  });

  // ── SHEET "ADD TO CART" ─────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var sheetAtc = e.target.closest && e.target.closest('.sheet-atc');
    if (!sheetAtc) return;
    e.preventDefault();
    e.stopPropagation();

    var pid = sheetAtc.getAttribute('data-product-id');
    var row = document.getElementById('sheet-sizes-' + pid);
    if (!row) return;
    var selected = row.querySelector('.size-btn.size-selected');
    if (!selected) {
      log('sheet add: no size selected', pid);
      return;
    }
    var variantId = selected.getAttribute('data-variant-id');
    if (!variantId) return;

    sheetAtc.setAttribute('disabled', 'disabled');

    // Request the cart-drawer section in the SAME response so the
    // Peanut cart drawer's fetch hook can swap + auto-open without a
    // second round-trip (avoids a race with refreshInFlight).
    var body = { id: variantId, quantity: 1, sections: 'cart-drawer' };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add.js ' + res.status);
        return res.json();
      })
      .then(function () {
        closeSheet(pid, true);
        // No explicit cart:refresh dispatch — the cart drawer's window.fetch
        // hook already intercepts /cart/add.js and drives its own refresh +
        // auto-open. Dispatching here would race and hit refreshInFlight.
      })
      .catch(function (err) {
        console.error('[peanut-card] add-to-cart failed:', err);
        sheetAtc.removeAttribute('disabled');
      });
  });

  // ── DIRECT ATC (products without a size option) ─────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.atc.direct-atc');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    btn.setAttribute('disabled', 'disabled');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: 1, sections: 'cart-drawer' })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add.js ' + res.status);
        return res.json();
      })
      .then(function () {
        btn.removeAttribute('disabled');
        // Cart drawer handles auto-open via its fetch hook — no extra dispatch.
      })
      .catch(function (err) {
        console.error('[peanut-card] direct add-to-cart failed:', err);
        btn.removeAttribute('disabled');
      });
  });

  // ── HELPERS ─────────────────────────────────────────────────────────────
  function openSheet(pid, triggerBtn) {
    var overlay = document.getElementById('sheet-overlay-' + pid);
    var sheet   = document.getElementById('size-sheet-' + pid);
    if (!overlay || !sheet) return;
    overlay.classList.add('active');
    overlay.setAttribute('aria-hidden', 'false');
    if (triggerBtn) triggerBtn.setAttribute('aria-expanded', 'true');

    requestAnimationFrame(function () {
      sheet.classList.add('open');
      var first = sheet.querySelector('.size-btn');
      if (first && !sheet.querySelector('.size-btn.size-selected')) {
        first.focus({ preventScroll: true });
      } else if (first) {
        var selected = sheet.querySelector('.size-btn.size-selected');
        (selected || first).focus({ preventScroll: true });
      }
    });
    log('openSheet', pid);
  }

  function closeSheet(pid, committed) {
    var overlay = document.getElementById('sheet-overlay-' + pid);
    var sheet   = document.getElementById('size-sheet-' + pid);
    var atcBtn  = document.getElementById('atc-' + pid);
    if (!overlay || !sheet) return;

    sheet.classList.remove('open');

    var cleanup = function () {
      overlay.classList.remove('active');
      overlay.setAttribute('aria-hidden', 'true');
    };

    var done = false;
    var onEnd = function () {
      if (done) return;
      done = true;
      cleanup();
      sheet.removeEventListener('transitionend', onEnd);
    };
    sheet.addEventListener('transitionend', onEnd, { once: true });
    setTimeout(onEnd, 400);

    if (atcBtn) {
      atcBtn.setAttribute('aria-expanded', 'false');
      if (committed) {
        atcBtn.textContent = 'Add to Cart';
        atcBtn.classList.remove('select-size-state');
        atcBtn.focus({ preventScroll: true });
      }
    }
    log('closeSheet', pid, 'committed:', committed);
  }
})();
